import { isSpotsAreUndefined } from '../../components/Registration/Steps/FillForm/index.utils'
import { dateNow, toDate } from '../../utils/DateHelpers'

export const GetEventDateObject = (date) => {
    const startDate = date.start?.iso
    const endDate = date.end?.iso
    if (!startDate) {
        return { start: endDate, end: endDate }
    } else if (!endDate) {
        return { start: startDate, end: startDate }
    } else {
        return { start: startDate, end: endDate }
    }
}

export const calculRegistrationState = (ticketing, competitionDivisions, total_participants, suffix = '') => {
    if (ticketing && ticketing?.publish) {
        const now = dateNow()
        const open_date = toDate(ticketing.open_date)

        if (open_date?.isAfter(now)) {
            return `${'OPEN AT'} ${open_date.format()}` // handled differently in display
        }

        const end_date = toDate(ticketing.end_date)

        if (end_date?.isBefore(now)) {
            return false
        }

        if (!isSpotsAreUndefined(ticketing.total_spots)) {
            if (total_participants >= parseInt(ticketing.total_spots)) {
                return 'SOLD OUT'
            } else {
                return 'REGISTER NOW' + suffix
            }
        } else if (!competitionDivisions) {
            return 'REGISTER NOW' + suffix
        } else if (competitionDivisions) {
            let existingDivisionsSpots =
                ticketing?.specific_division_spots?.filter((o) =>
                    competitionDivisions?.find((x) => x._id == o.division_id),
                ) || []
            if (existingDivisionsSpots.length > 0) {
                // Validate and fill missing divisions
                if (existingDivisionsSpots.length < competitionDivisions.length) {
                    const missingDivisions = competitionDivisions.filter(
                        (division) => !existingDivisionsSpots.find((spot) => spot.division_id === division._id),
                    )
                    const newSpots = missingDivisions.map((division) => ({
                        division_id: division._id,
                        division_spots: null,
                        whitelist: [],
                        _id: `${division._id}-generated`,
                    }))
                    existingDivisionsSpots = [...existingDivisionsSpots, ...newSpots]
                }
                // return REGISTER NOW if there is at least one empty spot in any division

                for (let i = 0; i < existingDivisionsSpots.length; i++) {
                    const division = existingDivisionsSpots[i]

                    const divisionFound = competitionDivisions.find((x) => x._id == division.division_id)

                    // Event/home payloads use participants_count; registration findCompetition uses
                    // total_participants. Reading only the former made the banner always "Sold Out"
                    // on /registration when caps are per-division (e.g. event 3433).
                    const booked =
                        divisionFound?.participants_count ?? divisionFound?.total_participants ?? 0

                    // if division_spots is not set or if the division participants are less than the division_spots
                    if (
                        !divisionFound ||
                        isSpotsAreUndefined(division.division_spots) ||
                        booked < division.division_spots
                    ) {
                        return 'REGISTER NOW'
                    }
                }
            } else if (competitionDivisions.length > 0) {
                return 'REGISTER NOW'
            }

            return 'SOLD OUT'
        }
    }
    // console.log('---return false');
    return false
}

export const isPublish = (object) => {
    return object?.publish || false
}
